<div class="goa-error-bar mb-20" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
	<mat-icon>error_outline</mat-icon>
	<div class="errors">
		<ng-content></ng-content>
	</div>
</div>
